import { QUEST_REWARD_TYPE } from "../quests/quest.enums";
import { z } from "zod";

export const SpinningWheelSlotsSchema = z.object({
  questId: z.number().nonnegative(),
  slots: z.array(
    z.object({
      rewardCount: z.number().nonnegative(),
      rewardType: z.nativeEnum(QUEST_REWARD_TYPE),
    }),
  ),
});
export type SpinningWheelSlots = z.infer<typeof SpinningWheelSlotsSchema>;
